import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PublishDate = makeShortcode("PublishDate");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`At the suggestion of my son Alexander, the two of us recently took a trip back
to where I first did  fieldwork for the Geological Survey of Botswana, starting
in 1970 - the Okavango Delta in the NW  corner of the country. We flew directly
to Maun from Johannesburg and, after an initial overnight camping trip by
motorboat and makoro, picked up a rented 4x4. We set off NE towards Shorobe
with a plan to drive all around the Okavango Delta, taking advantage of the 400
km Four Rivers  Highway along the length of the Caprivi Strip (Namibia) and the
tar road from the Mohembo  border crossing back to Maun via Lake Ngami. Despite
a number of typical bush-driving setbacks,  we completed the 1433 km camping
trip in seven days, about one-third of it on dirt roads. `}</p>
    <p>{`A selection of pictures from our journey may be found `}<a parentName="p" {...{
        "href": "/reevesdotnl/"
      }}>{`here`}</a>{`. `}{`[The original photos
have been  recovered but the order is no longer entirely correct. Thank you,
Google.]`}{` `}</p>
    <p>{`As well as the advent of tar roads, many other things have changed in 40+ years
`}{`-`}{` but mostly for  the better. One of the greatest challenges in 1970 was finding
accurate locations for more than  1500 gravity observation points in and around
the Delta. Nowadays this is easily achieveable using  the GPS on the i-Phone I
use every day, as well as on my camera. Maun was virtually  unrecognisable with
new supermarkets, schools and hospitals, as well as a good road network. The
old terminal building at the airport still stands, dwarfed by more modern
structures. And the old  general store at Sehitwa - a distinctive corrugated
iron building - can still be found, hidden behind  a more modern facade. The
water level in Lake Ngami was very close to Sehitwa and the Kunyere  River was
flowing fast at Toteng and teeming with fish. Similarly, the Savuti Channel at
the north  end of the Mababe Depresion was full of water. `}</p>
    <p>{`Food for thought in trying to understand the hydrology, geomorphology - and
seismicity! - of this  fascinating corner of the world. The shear size of
everything is exhilirating to those of us more  used to European dimensions.
Earlier this year the Okavango Delta was declared the 1000th World  Heritage
Site. `}</p>
    <PublishDate mdxType="PublishDate" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      